import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../../services/apirest";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import moment from "moment";
import Notify from "../../../../../Notify";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { getData, putData } from "../../../../../../services/library";

function BajaZona(props) {
    const [datosZona, setDatosZona] = useState(props.zona);
    const [observaciones, setObservaciones] = useState("");
    const [fechaInactivo, setFechaInactivo] = useState("");
    const [disBtn, setDisBtn] = useState(false);
  
    const handleClose = () => {
      props.setOpen(false)
    };
  
    const [notificacion, setNotificacion] = useState({
      open: false,
      mensaje: "",
      severity: "",
      color: "",
    });
  
    async function marcarInactivo(e) {
      setDisBtn(true);
      putData(
        e,
        "/envasado_zona/" + datosZona.id,
        {
          activo: 0,
        },
        setNotificacion
      );
    }
    return (
      <div>
        <Dialog open={props.open} onClose={handleClose}>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={() => {
                props.actualizar();
                props.setOpen(false);
                setNotificacion({open:false})
              }}
              severity={notificacion.severity}
            />
          ) : null}
          <form onSubmit={marcarInactivo}>
            <Box backgroundColor={"#1F618D"}>
              <DialogTitle>
                <Typography color="#ffffff" fontSize={20}>
                  Baja de Zona: {datosZona.nombre}
                </Typography>
              </DialogTitle>
            </Box>
            <DialogContent>
              <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere dar de baja la zona?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Stack spacing={45} direction="row">
                <Button
                  color="error"
                  disabled={disBtn}
                  variant="contained"
                  onClick={handleClose}
                >
                  Cancelar
                </Button>
                <Button
                  color="success"
                  type="submit"
                  variant="contained"
                  disabled={disBtn}
                >
                  Confirmar
                </Button>
              </Stack>
            </DialogActions>
          </form>
        </Dialog>
      </div>
  )
}

export default BajaZona